import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-incoming-actions',
  templateUrl: './incoming-actions.component.html',
  styleUrls: ['./incoming-actions.component.css']
})
export class IncomingActionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
